import React, { useId } from 'react';

const BIG_STAR = 'M14.5 6.5C15 11 18 14 22.5 14.5C18 15 15 18 14.5 22.5C14 18 11 15 6.5 14.5C11 14 14 11 14.5 6.5Z';
const SMALL_STAR = 'M6 1.5C6.3 4.2 7.8 5.7 10.5 6C7.8 6.3 6.3 7.8 6 10.5C5.7 7.8 4.2 6.3 1.5 6C4.2 5.7 5.7 4.2 6 1.5Z';

/** Ava's sparkle glyph alone (decorative — the sender label carries the meaning). */
export function AvaSparkle({ size = 16 }) {
  const gradientId = `ava-sparkle-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={gradientId} x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: 'var(--wi-ava-from)' }} />
          <stop offset="1" style={{ stopColor: 'var(--wi-ava-to)' }} />
        </linearGradient>
      </defs>
      <path fill={`url(#${gradientId})`} d={BIG_STAR} />
      <path fill={`url(#${gradientId})`} d={SMALL_STAR} />
    </svg>
  );
}

/** Ava's round avatar — the sparkle on its tint chip. */
export default function AvaAvatar({ size = 32 }) {
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        background: 'var(--wi-ava-chip-bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AvaSparkle size={Math.round(size * 0.56)} />
    </div>
  );
}
